// src/components/Common/LoaderStatic.jsx
import React from "react";
import "./Loader.scss";

const LoaderStatic = () => (
  <div className="novian-loader-backdrop">
    <div className="novian-loader-content">
      <div className="dual-ring-spinner" />
      <p className="novian-loader-text">
        <strong>Cargando</strong><span className="dots">...</span>
      </p>
    </div>
  </div>
);

export default LoaderStatic;